import { Box, useTheme } from "@mui/material";

import { FormDivider } from "../../../../components/forms-design-system/FormDivider";
import { Trans, useTranslate } from "../../../../hooks/useTranslate";

import { FormTypography } from "@/forms-design-system/FormTypography";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

export const GiftAidDetails = () => {
  const theme = useTheme();
  const { t } = useTranslate();

  if (!theme.palette.forms || !theme.palette.formsComponents?.giftAidBlock) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Box
      sx={{
        color: theme.palette.formsComponents.giftAidBlock.contentTextColor,
        ["& ul"]: { paddingLeft: 2 },
      }}
    >
      <Box>
        <FormDivider sx={{ mb: 2, mt: 2 }} />
      </Box>
      <FormTypography variant="subtitle2" vibe="moderate" sx={{ mb: 1 }}>
        {t("dashboard", "giftAidBlock.details.title")}
      </FormTypography>
      <ul>
        <li>
          <FormTypography variant="body2" vibe="moderate">
            {t("dashboard", "giftAidBlock.details.item1")}
          </FormTypography>
        </li>
        <li>
          <FormTypography variant="body2" vibe="moderate">
            {t("dashboard", "giftAidBlock.details.item2")}
          </FormTypography>
        </li>
        <li>
          <FormTypography variant="body2" vibe="moderate">
            {t("dashboard", "giftAidBlock.details.item3")}
          </FormTypography>
        </li>
        <li>
          <FormTypography variant="body2" vibe="moderate">
            {t("dashboard", "giftAidBlock.details.item4")}
          </FormTypography>
        </li>
        <li>
          <FormTypography variant="body2" vibe="moderate">
            <Trans
              space="dashboard"
              i18nKey="giftAidBlock.details.item5"
              components={{ a: <FormTypography variant="body2" component="span" vibe="brand" /> }}
            />
          </FormTypography>
        </li>
      </ul>
    </Box>
  );
};
